module.exports = __webpack_public_path__ + "img/SiGe-n.0c37542e.svg";